var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"vortex",style:(_vm.style)},_vm._l((_vm.tiles),function(tile,index){return _c('flux-image',{key:index,ref:"tiles",refInFor:true,attrs:{"size":_vm.size,"image":_vm.img,"offset":tile.offset,"css":tile.css}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }